<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ ModelProcedure.UnitFullName }}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>NUEVO VECINO: FORMULARIO PARA REGISTRARSE</p>
            </div>
            <p
              v-if="ProcedureInitDescription != undefined"
              class="empadronamiento__form_header_info_text"
              v-html="ProcedureInitDescription"
            ></p>
            <div class="base-select loading-animation" v-if="loading"></div>
            <base-select
              placeholder="Finalidad de compra *"
              v-else
              v-model="ModelProcedure.PurchasePurposeId"
              :options="Enums.PurchasePurpose"
              :invalid="
                $v.ModelProcedure.PurchasePurposeId.$invalid && submitted
              "
            />

            <template v-for="(attach, i) in attachsSell">
              <base-file-upload
                :key="i"
                :keyIndex="i"
                :attach="attach"
                :showTooltipActive="showTooltipActive"
                @changeTooltipActive="showTooltipActive = $event"
                @change="uploadFile"
                @clearUpload="clearFile"
                :modelProp="getAttachModelPropName(attach)"
                :state="ModelProcedure[getAttachModelPropName(attach)]"
                :invalid="getAttachValidator(attach).$invalid && submitted"
                :previewURL="getAttachPreviewURL(attach)"
              />

              <p
                :key="'p' + i.toString()"
                v-if="attach.Code === 'ProcedureAttachment.SaleDocument'"
                class="empadronamiento__intro__main__form__container__notes"
              >
                El adjunto debe ser en formato PDF, conteniendo todas las hojas
                del contrato y contener las firmas de ambas partes
              </p>
            </template>
          </fieldset>
        </form>

        <div class="empadronamiento__intro__button">
          <div></div>
          <button v-if="!loadingForm" class="active" @click="sendForm()">
            Continuar
          </button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
    <div
      v-if="showTooltipActive != ''"
      class="tooltip-background"
      @click="showTooltipActive = ''"
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { required, not } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      loading: true,
      submitted: false,
      section: "PROCEDURE",
      loadingForm: false,
      showTooltipActive: "",
      ProcedureInitDescription: null,
    };
  },
  computed: {
    ...mapState({
      Enums: (state) => state.neighregistration.Enums,
      ModelProcedure: (state) => state.manageVecino.ModelProcedure,
    }),
    ...mapGetters(["attachsSell"]),
    text() {
      //return ProcedureInitDescription;
      return "";
    },
  },
  mounted() {
    // 034770fa-d643-45cc-8367-42aab6618f9f
    const self = this;
    this.$store
      .dispatch("getProcedure", {
        ucode: this.$route.query.ucode,
      })
      .then(() => {
        self.$store
          .dispatch("getProcedureInitDescription", {
            ucode: this.$route.query.ucode,
          })
          .then((terms) => {
            self.ProcedureInitDescription = terms.ProcedureInitDescription;
          });
        self.$store.dispatch("getEnums");
        self.loading = false;

        if (self.$v.ModelProcedure.ProcedureType.$invalid) {
          self.$router.replace("/vecino/invalid/");
        }
      });
  },
  created() {
    this.$store.dispatch("getProcedureInitDescription", {
      ucode: this.$route.query.ucode,
    });
  },
  methods: {
    getAttachPreviewURL(attach) {
      let attachId = null;
      attachId = this.ModelProcedure[this.getAttachModelPropName(attach)];
      if (attachId != null) {
        return `${
          process.env.VUE_APP_URL_API
        }/neighregistration/procedureattachment/preview/${attachId}`;
      }
      return "";
    },
    sendForm() {
      const self = this;
      self.submitted = true;
      self.$v.$touch();
      if (!self.isInvalidForm()) {
        self.loadingForm = true;
        self.ModelProcedure.PurchasePurposeId = Number(
          self.ModelProcedure.PurchasePurposeId
        );
        self.$store
          .dispatch("updateProcedure", {
            model: self.ModelProcedure,
          })
          .then(() => {
            self.loadingForm = false;
            self.$router.push(
              `/vecino/titularPropietario/0?ucode=${self.$route.query.ucode}`
            );
          });
      } else {
        var element = document.querySelector(
          ".empadronamiento__intro__main__form__container-item .has-error"
        );
        if (element != null)
          element.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },
    getAttachModelPropName({ Name }) {
      if (this.attachsSell.length === 0) return "";
      const returnValue = this.$store.getters.findAttachPropByName(
        Name,
        this.section
      );
      return returnValue;
    },
    getAttachValidator(attach) {
      if (this.attachsSell.length === 0) return false;
      const propName = this.getAttachModelPropName(attach);
      return this.$v.ModelProcedure[propName];
    },
    uploadFile({ file, attach, attachmentTypeId, modelProp }) {
      const self = this;
      const section = self.section;
      if (attach.Code === "ProcedureAttachment.SaleDocument") {
        const validExtensions = ["pdf"];
        const fileExtension = file.name
          .split(".")
          .pop()
          .toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "Formato no permitido. La extension permitida es: pdf."
          );
          return;
        }
      }
      this.$store
        .dispatch("uploadFile", { file, attachmentTypeId, section })
        .then((res) => (self.ModelProcedure[modelProp] = res));
      self.getAttachValidator(attach, this.section).$touch();
    },
    clearFile({ modelProp }) {
      const self = this;
      self.ModelProcedure[modelProp] = 0;
    },
    isInvalidForm() {
      return (
        this.$v.ModelProcedure.ProcedureType.$invalid ||
        this.$v.ModelProcedure.PurchasePurposeId.$invalid ||
        this.$v.ModelProcedure.SaleDocument.$invalid
      );
    },
  },
  validations: {
    ModelProcedure: {
      ProcedureType: {
        not: not((model) => model === 2),
      },
      PurchasePurposeId: {
        required,
        not: not((model) => model === 0),
      },
      SaleDocument: {
        required,
        not: not((model) => model === 0),
      },
      PublicServiceBill: {
        //required,
        //not: not((model) => model === 0),
      },
    },
  },
};
</script>
